import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

import Network from '@/Network'
import PolicyLinksManager from '@/components/designSystem/PolicyLinksManager/index.vue'
import type { PolicyLinksAdapter } from '@/components/designSystem/PolicyLinksManager/types'
import type {
  ListQualificationDocumentalPolicyLinksResponse,
  QualificationDocumentalPolicyLinkItem
} from '@/Network/Types/Responses/QualificationDocumentalResponses'
import type { UpdateQualificationDocumentalPolicyLinksRequest } from '@/Network/Types/Requests/QualificationDocumentalRequests'
import { AuthorizationResourcesAndSubjects } from '@/types/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationDocPolicyTab',
  props: {
    resourceType: {},
    resourceId: {},
    companyId: {}
  },
  emits: ["update:isSaving", "update:hasUnsavedChanges"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const service = Network.qualificationDocumentalPolicy

const listByType: Partial<
  Record<
    AuthorizationResourcesAndSubjects,
    (id: number) => Promise<ListQualificationDocumentalPolicyLinksResponse>
  >
> = {
  [AuthorizationResourcesAndSubjects.Company]: (id) => service.listCompanyPolicyLinks(id),
  [AuthorizationResourcesAndSubjects.HealthUnit]: (id) => service.listHealthUnitPolicyLinks(id),
  [AuthorizationResourcesAndSubjects.Position]: (id) => service.listPositionPolicyLinks(id)
}

const updateByType: Partial<
  Record<
    AuthorizationResourcesAndSubjects,
    (id: number, payload: UpdateQualificationDocumentalPolicyLinksRequest) => Promise<void>
  >
> = {
  [AuthorizationResourcesAndSubjects.Company]: (id, payload) =>
    service.updateCompanyPolicyLinks(id, payload),
  [AuthorizationResourcesAndSubjects.HealthUnit]: (id, payload) =>
    service.updateHealthUnitPolicyLinks(id, payload),
  [AuthorizationResourcesAndSubjects.Position]: (id, payload) =>
    service.updatePositionPolicyLinks(id, payload)
}

// endDate null = vigência aberta (permitida pelo backend só na última política).
// A UI atual não edita vigência aberta: o item renderiza sem data final e o save
// exige preenchê-la — suportar edição de vigência aberta é follow-up de produto.
const toListItem = (item: QualificationDocumentalPolicyLinkItem) => ({
  policyId: item.qualificationDocumentalPolicy.id,
  policyName: item.qualificationDocumentalPolicy.name,
  startDate: item.startDate,
  endDate: item.endDate ?? '',
  linkedAt: item.createdAt,
  linkedBy: item.linkedBy?.name ?? ''
})

const adapter: PolicyLinksAdapter = {
  policyColumnLabel: 'Política de qualificação documental',
  listLinks: async (resourceType, resourceId) => {
    const list = listByType[resourceType]
    if (!list)
      throw new Error('Tipo de recurso não suportado para políticas de qualificação documental.')
    const response = await list(resourceId)
    return response.data.map(toListItem)
  },
  saveLinks: async (resourceType, resourceId, items) => {
    const update = updateByType[resourceType]
    if (!update)
      throw new Error('Tipo de recurso não suportado para políticas de qualificação documental.')
    await update(resourceId, { policies: items })
  },
  fetchPolicyOptions: async (params) => {
    const response = await service.listPolicyOptions(params)
    return response.data
  }
}

const managerRef = ref<InstanceType<typeof PolicyLinksManager> | null>(null)

const handleSave = async () => {
  await managerRef.value?.handleSave()
}

__expose({ handleSave })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PolicyLinksManager, {
    ref_key: "managerRef",
    ref: managerRef,
    "resource-type": props.resourceType,
    "resource-id": props.resourceId,
    "company-id": props.companyId,
    adapter: adapter,
    "bypass-edit-permission": "",
    "onUpdate:isSaving": _cache[0] || (_cache[0] = ($event: any) => (emit('update:isSaving', $event))),
    "onUpdate:hasUnsavedChanges": _cache[1] || (_cache[1] = ($event: any) => (emit('update:hasUnsavedChanges', $event)))
  }, null, 8, ["resource-type", "resource-id", "company-id"]))
}
}

})